export default "__VITE_ASSET__BRlz8d3T__"